//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceIntent, PaymentProcessorType } from './Enums';

export abstract class PaymentSourceInputItem extends ItemBase {
    Intent: PaymentSourceIntent = PaymentSourceIntent.Pay;
    Surcharge: number | null = null;
    Total: number | null = null;
    ParentID: string | null = null;
    FamilyID: string | null = null;
    PaymentProcessorID: string | null = null;
    AutoPay: boolean | null = null;
    OrderIndex: number | null = null;
    abstract readonly ProcessorType: PaymentProcessorType;

    static readonly ClassName: string = "PaymentSourceInputItem";
}
